module.exports = __webpack_public_path__ + "media/src/images/pulse_logo_centered-3cecc7ec5f97e3d86b51fdd6b5574958.png";